import { render, staticRenderFns } from "./ProductContentLQTajwid.vue?vue&type=template&id=6ecddbff&scoped=true&"
import script from "./ProductContentLQTajwid.vue?vue&type=script&lang=js&"
export * from "./ProductContentLQTajwid.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentLQTajwid.vue?vue&type=style&index=0&id=6ecddbff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecddbff",
  null
  
)

export default component.exports